import { useDeskId } from './useDeskId';
import useDesks from './useDesks';

/**
 * Returns true when the current desk has an active WhatsApp integration.
 * Use this to gate WhatsApp-specific UI affordances (character counters,
 * advisory copy, etc.) so they don't appear for non-WhatsApp customers.
 */
const useWhatsAppActive = (): boolean => {
  const deskId = useDeskId();
  const { desk } = useDesks(deskId);
  return !!desk?.integrations?.some((int) => int.type === 'whatsapp' && int.active);
};

export default useWhatsAppActive;
